import React from 'react';
import ReactDOM from 'react-dom';

import Portal from 'react-portal';
import FullScreenOverlay from './FullScreenOverlay.js';

import axios from 'axios';

class AcceptTerms extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            accepted_terms:false,
            accepted_dpa:false,
            accepted_privacy:false,
        }
    }

    accept = (e) => {
        e.stopPropagation();

        axios.post('/accounts/terms').then(() => {

        });

        this.props.onAccept(this.props.param);
    }

    canContinue = () => {
        return this.state.accepted_terms && this.state.accepted_dpa && this.state.accepted_privacy;
    }

    acceptTerms = () => {
        this.setState({
            accepted_terms:!this.state.accepted_terms,
        });
    }
    acceptDpa = () => {
        this.setState({
            accepted_dpa:!this.state.accepted_dpa,
        });
    }
    acceptPrivacy = () => {
        this.setState({
            accepted_privacy:!this.state.accepted_privacy,
        });
    }

    render() {
        return <Portal onClose={this.props.onClose} isOpened={(this.props.param !== false ? true:false)}>
            <FullScreenOverlay hideCloseButton={true}>
                <div className="overview m-t-30 col-sm-6 offset-sm-3 text-center">
                    <h1>Terms and agreements</h1>
                    <div className="col-sm-12 text-center">
                        <h2>
                            Thank you for using Crall.io and we're glad to have you as a customer.<br />
                            Before you can use our services we need you to accept the following terms.

                        </h2>

                        <div className="m-t-30 col-sm-6 offset-sm-4 text-left">
                            <div className="form-group">
                                <div className="checkbox-custom checkbox-default">
                                    <input type="checkbox" onChange={this.acceptTerms} checked={this.state.accepted_terms} autoComplete="off" />
                                    <label>I accept the <a href="https://crall.io/terms/" target="_blank">Terms and conditions</a></label>
                                </div>

                                <div className="checkbox-custom checkbox-default">
                                    <input type="checkbox" onChange={this.acceptPrivacy} checked={this.state.accepted_privacy} autoComplete="off" />
                                    <label>I accept the <a href="https://crall.io/privacy/" target="_blank">Privacy Policy</a></label>
                                </div>

                                <div className="checkbox-custom checkbox-default">
                                    <input type="checkbox" onChange={this.acceptDpa} checked={this.state.accepted_dpa} autoComplete="off" />
                                    <label>I accept the <a href="https://crall.io/data-processing-agreement/" target="_blank">Data Processing Agreement</a></label>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="m-t-30 text-center col-sm-12">
                        <button disabled={!this.canContinue()} onClick={this.accept} className="btn btn-lg btn-dark">
                            <span><i className="icon wb-check"></i>Continue</span>
                        </button>
                    </div>


                </div>
            </FullScreenOverlay>
        </Portal>
    }
}

export default AcceptTerms;



// WEBPACK FOOTER //
// ./components/AcceptTerms.js